import React, { useState } from 'react';
import '../assets/Faq.css';

const faqData = [

    {
        question: "Is the land title clear?",
        answer: "Yes, the land has a clear and marketable title."
    },

    {
        question: "Can I get a bank loan on Agri land? Which banks are financing agricultural land?",
        answer: "Yes, bank loans can be arranged depending on the type and documentation of the land. For agricultural land, loans are generally provided by nationalized banks, cooperative banks, and certain private sector institutions under specific schemes. Banks like SBI, Bank of Maharashtra, HDFC Rural, and local cooperative banks often finance agricultural or semi-developed land, provided the buyer meets eligibility criteria and the land has clear titles and proper access. Samriddhi Group assists you in the loan process with necessary paperwork and coordination support."
    },

    {
        question: "What is the legal procedure?",
        answer: "The legal procedure involves due diligence, title verification, agreement drafting, registration, and stamp duty payment."
    },
    {
        question: "Is the land safe (legally and physically)?",
        answer: "Yes, the land is thoroughly vetted for legal disputes and is in a safe physical location."
    },
    {
        question: "Who is the current legal owner? Is there any dispute or joint ownership?",
        answer: "Samriddhi Group Builders and developers is the only owners."
    },
    {
        question: "Is the land road-facing or does it have proper access?",
        answer: "Yes, every Samriddhi Group project is thoughtfully planned at a strategic location with excellent road connectivity. Whether it’s a main road touch plot or internal road access, we ensure that your land is easily accessible, well-connected to nearby highways or landmarks, and future-ready for seamless mobility.."
    },
    {
        question: "Is the land in a future development zone or near an upcoming project (like Ring Road, airport, industrial park)?",
        answer: "Absolutely. Samriddhi Group carefully selects land parcels in high-growth corridors that are aligned with upcoming government infrastructure like Ring Roads, airports, and industrial parks. These future-ready locations are poised for exponential appreciation, ensuring your investment not only grows in value but also benefits from planned urban and industrial development in the vicinity."
    },

];

const Faq = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (

        <div className='faq-outer-container'>

            <div className="faq-container">
                <h1 className="faq-heading">FAQ</h1>
                {/* <button className="ask-question-btn">Ask Question</button> */}
                {faqData.map((item, index) => (
                    <div
                        key={index}
                        className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                        onClick={() => toggleFAQ(index)}
                    >
                        <div className="faq-question">
                            {item.question}
                            <span className={`arrow ${activeIndex === index ? 'up' : 'down'}`}></span>
                        </div>
                        <div className="faq-answer">{item.answer}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Faq;
